<script setup>
/**
 * Se usa para filtro en los listados
 */
import { orderBy } from 'lodash';
import ge from '@/api/ge';
import { ref, watch } from 'vue';
import SelectCifra from '../../../components/inputs/SelectCifra.vue';

const props = defineProps({
  multiple: { type: Boolean, value: true },
  modelValue: { type: Array, default: () => ([]) },
});

const emits = defineEmits(['update:modelValue']);

const modelInterno = ref(props.modelValue);

const options = ref([]);

ge.modalidades.getAgrupadasSelect2({ params: {} }).then((data) => {
  options.value = orderBy(data, [(item) => item.text.toLowerCase()]);
});

watch(modelInterno, (value) => {
  emits('update:modelValue', value);
});

</script>

<template>
  <SelectCifra
    v-model="modelInterno"
    :opciones="options"
    :multiple="multiple"
    campo-etiqueta="text"
    campo-id="id"
  >
  </SelectCifra>
</template>
